import { APP_STORE_KEY_PREFIX } from "@/config/app.config";
import { encryption } from "@/utils/md5-utils";
import { decryptData, encryptData } from "@/utils/crypto-utils";

/**
 * @description 格式化存储键
 * @param key
 * @returns {string}
 */
function formatStoreKey(key) {
  return encryption(`${APP_STORE_KEY_PREFIX}-${key}`);
}

export const setStore = (key = "", value) => {
  let value_ = value;

  try {
    if (typeof value_ === "object") {
      value_ = JSON.stringify(JSON.parse(JSON.stringify(value_)));
    }
  } catch (e) {
    console.log("setStore error:", e);
  }

  localStorage.setItem(formatStoreKey(key), encryptData(value_));
};

export const getStore = (key = "", type, empty) => {
  let data;

  try {
    let item = localStorage.getItem(formatStoreKey(key));
    if (item) item = decryptData(item);

    switch (type) {
      case "b":
        data = item === "true";
        break;
      case "n":
        data = Number(item) || empty;
        break;
      case "o":
        data = item ? JSON.parse(item) : empty;
        break;
      default:
        data = item || empty;
        break;
    }
  } catch (e) {
    console.log("getStore error:", e);
  }

  return data;
};

export function removeStore(key = "") {
  localStorage.removeItem(formatStoreKey(key));
}
